import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {CallsHistoryIframePage} from './calls-history-iframe-page/calls-history-iframe.page';
import {CallsAicoachPage} from './calls-aicoach-page/calls-aicoach.page';
import {CallsHistoryPage} from './calls-history-page/calls-history.page';
import {CallDetailsPage} from './call-details-page/call-details.page';
import { CallsDashboardPage } from './calls-dashboard-page/calls-dashboard.page';
import { ManagerOnlyGuard } from 'src/app/guards/manager-only.guard';
import { AuthOnlyGuard } from 'src/app/guards/auth-only.guard';
import {CallsTeamDashboardPage} from './calls-team-dashboard-page/calls-team-dashboard.page';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'history',
    pathMatch: 'full'
  },
  {
    path: 'aicoach/:task_id/:aicoach_id',
    component: CallsAicoachPage
  },
  {
    path: 'history-iframe',
    component: CallsHistoryIframePage
  },
  // {
  //   path: 'history',
  //   component: CallsHistoryIframePage
  // },
  {
    path: 'history',
    component: CallsHistoryPage
  },
  {
    path: 'scorecard/:callId',
    component: CallDetailsPage
  },
  {
    path: 'team/dashboard',
    component: CallsTeamDashboardPage,
    canActivate: [ManagerOnlyGuard]
  },
  {
    path: 'dashboard',
    component: CallsDashboardPage,
    canActivate: [AuthOnlyGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CallsRoutingModule {
}
